import classes from './Button.module.css';

type ButtonProps = {
  children?: React.ReactNode;
  onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  disabled?: React.ButtonHTMLAttributes<HTMLButtonElement>['disabled'];
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  extraStyles?: React.CSSProperties;
};

const Button = (props: ButtonProps) => {
  return (
    <button
      className={classes.button}
      disabled={props.disabled}
      onClick={props.onClick}
      style={props.extraStyles}
      type={props.type}
    >
      {props.children}
    </button>
  );
};

export default Button;
